<template>
  <div class="alert alert-info" role="alert">
    This account needs a subscription to Speedify in order to purchase server subscriptions. We have added one for you.
  </div>
</template>
